import { defineComponent } from "vue";
import DetalhesNotasFiscaisViewModel from "@/shared/view-models/DetalhesNotasFiscaisViewModel";
import Tools from "@/shared/services/tools";
import gPdf from "@/components/g-pdf/g-pdf.vue"
import PDFNotaFiscal from "../PDF/PDFNotaFiscal.vue";

const name = 'DetalhesNotasFiscais'

export default defineComponent({
  name,

  components: {
    'g-pdf': gPdf,
    PDFNotaFiscal
  },

  props: {},

  mounted() {
    this.GetDetalhesNotasFiscais();

    var notaId = this.$route.params.id    
    this.NotaFiscalId = notaId
  },

  updated() { },

  data() {
    return {
      detalhesNotasFiscaisViewModel: new DetalhesNotasFiscaisViewModel(),
      NotaFiscalId: null,      
      executarvisualizacao: 0,
      renderiza: false,
      podeBaixarPdf: false,
      abrePdf: false,
    }
  },

  methods: {
    GetDetalhesNotasFiscais() {
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesNotasFiscais/${this.$route.params.id}`,
      })
      .then((response) => {
        Tools.objectCustomAssign(this.detalhesNotasFiscaisViewModel, Tools.captalizeKeys(response.data.data))
      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },

    gerarPdf() {
      setTimeout(() => {
        this.executarvisualizacao++
      }, "500");
    },

    abrirPDF() {
      this.renderiza = false

      setTimeout(() => {        
        this.renderiza = true
      }, 100);

      this.abrePdf = true
      this.podeBaixarPdf = false
    }, 

    baixarPDF() {
      this.renderiza = false

      setTimeout(() => {        
        this.renderiza = true
      }, 100);

      this.abrePdf = false
      this.podeBaixarPdf = true
    },

    voltar() {
      this.$router.back()
    },

    itensNotasFiscais() {
      this.$router.push(`/notas-fiscais-itens/${this.$route.params.id}`);
    },
}});